import { useCallback, useEffect, useRef, useState } from "react";

import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { confirmDialog } from "primereact/confirmdialog";
import { DataTable } from "primereact/datatable";
import { Toast } from "primereact/toast";

import Loading from "../../../../components/Loading";
import Menu from "../../../../components/Menu";

import api from "../../../../services/api";

export default function GasHistorico() {
    const [data, setData] = useState([]);

    const [initialDate, setInitialDate] = useState(new Date());
    const [finalDate, setFinalDate] = useState(new Date());

    const [isLoading, setIsLoading] = useState(false);

    const [lastFetch, setLastFetch] = useState(1);

    const toast = useRef();

    const showError = (error) => toast.current.show({ summary: 'Ocorreu um Erro', severity: 'error', detail: error.response ? error.response.data.message : error.message });
    const showSuccess = (response) => toast.current.show({ summary: 'Sucesso', severity: 'success', detail: response.data.message });

    const fetchData = useCallback(() => {
        setLastFetch(1);
        api.get("acabamento/gas").then(response => {
            setData(response.data);
        }).catch(error => {
            setData([]);
        });
    }, []);

    const handleDelete = (rowData) => {
        confirmDialog({
            header: "Excluir",
            message: "Você tem certeza que deseja excluir esse registro?",
            acceptLabel: 'Excluir',
            acceptClassName: 'p-button-danger',
            rejectLabel: "Cancelar",
            rejectClassName: "p-button-secondary",
            accept: () => {
                setIsLoading(true);
                api.get(`acabamento/gas/${rowData.id}/delete`).then(response => {
                    if(lastFetch === 1) {
                        fetchData();
                    } else {
                        handleSearch();
                    }

                    setIsLoading(false);
                    showSuccess(response);
                }).catch(error => {
                    showError(error);
                    setIsLoading(false);
                });
            }
        });
    }

    const handleSearch = () => {
        if(!initialDate || !finalDate)
            return

        let date1 = initialDate.getFullYear() + "-" + String(initialDate.getMonth() + 1).padStart(2, "0") + "-" + String(initialDate.getDate()).padStart(2, "0");
        let date2 = finalDate.getFullYear() + "-" + String(finalDate.getMonth() + 1).padStart(2, "0") + "-" + String(finalDate.getDate()).padStart(2, "0");

        setLastFetch(2);

        api.get("acabamento/gas", {
            params: {
                data_inicial: date1,
                data_final: date2
            }
        }).then(response => {
            setData(response.data);
        }).catch(error => {
            showError(error);
        });
    }

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    if(isLoading)
        return <Loading />
    
    return (
        <div>
            <Menu />
            <Toast ref={toast} />
            <Card
                className="p-m-1"
                title="Histórico - Gás"
            >
                <div className="p-d-flex p-flex-row p-jc-start">
                    <Calendar 
                        className="p-m-1"
                        dateFormat="dd/mm/yy"
                        mask="99/99/9999"
                        onChange={e => setInitialDate(e.value)}
                        placeholder="Data Inicial"
                        value={initialDate}
                    />

                    <Calendar 
                        className="p-m-1"
                        dateFormat="dd/mm/yy"
                        mask="99/99/9999"
                        onChange={e => setFinalDate(e.value)}
                        placeholder="Data Inicial"
                        value={finalDate}
                    />

                    <Button 
                        className="p-m-1 p-button-success"
                        icon="pi pi-search"
                        onClick={handleSearch}
                    />
                </div>
                <DataTable
                    emptyMessage="Nenhum registro encontrado."
                    responsiveLayout="scroll"
                    size="small"
                    value={data}
                >
                    <Column header="ID" field="id" />
                    <Column header="Data" field="dataf" sortable />
                    <Column header="Operador" field="operador" sortable />
                    <Column header="Tipo" field="tipof" sortable />
                    <Column header="Tanque" field="tanque" sortable />
                    <Column header="Inicial" field="inicial" sortable />
                    <Column header="Final" field="final" sortable />
                    <Column header="Ações" body={(rowData) => (
                        <div>
                            <Button 
                                className="p-button-danger"
                                icon="pi pi-trash"
                                onClick={() => handleDelete(rowData)}
                                title="Clique para excluir"
                            />
                        </div>
                    )} /> 
                </DataTable>
            </Card>
        </div>
    )
}